import { api } from "@/shared/api";

// 0926 第八批 Z3 起独立声明(不与 generated.ts 取交集):当时 api spec 里这条返回的是实体
// KbTagDefinition(isSystem 为 int、无 sortOrder),与前端形状交集会得到 never。
// 第九批 api Z9b 把接口改成 DTO(isSystem: boolean、sortOrder: int)—— 与此处**同形**;
// 下次 regen generated.ts 后可重新耦合到生成类型(届时删掉这份手写声明,改为从 generated 取)。
export type KbTagDefinition = {
  id: number;
  tenantCode: string;
  category: "scene" | "public";
  name: string;
  tagValue: string;
  isSystem: boolean;
  sortOrder: number;
  createdAt: string;
  // mark: not yet in api-spec.yaml (V24 proposal)
};

// POST /tenant/knowledge/tags body — 用户只填显示名;tag_value(关联 key,无人类语义)由后端自动生成。
export type CreateTagPayload = {
  name: string;
};

// local-only: B (backend schema gap) — PUT /tenant/knowledge/tags/{id} body
export type UpdateTagPayload = {
  name: string;
  sortOrder?: number;
};

// local-only: B (backend schema gap) — POST /tenant/knowledge/tags/sync-scene 返
export interface SyncSceneResult {
  tenantCode: string;
  industryCode: string | null;
  added: string[];
  updated: string[];
  removed: string[];
  conflicts: string[];
  message: string | null;
}

// local-only: B (backend schema gap) — GET /tenant/knowledge/tags/availability 返(2026-09-23)
// 口径 = ai 陪练出题取材:已审 + 向量化完成 + 租户库 + 全员可见,产品线 = 子树 ∪ 通用层。
// chunkCount 是 ingest 回写的切片数,是可出题内容的上限(ai 还会丢过短残片/无答案 Q&A)。
export interface KbTagAvailabilityCount {
  docCount: number;
  chunkCount: number;
}
export interface KbTagAvailability {
  /** 范围内一篇都没有的标签不出现 —— 按 0 处理 */
  tags: Array<KbTagAvailabilityCount & { tagValue: string }>;
  /** 范围内不分标签的合计 */
  total: KbTagAvailabilityCount;
  /** 带了 tags 参数时:挂了任一已选标签的合计(已去重);没带 → null */
  matched: KbTagAvailabilityCount | null;
  /** 是否真按产品线收窄;选了产品但都不在产品树里 → false(ai 同样退全库) */
  scoped: boolean;
}

function tenantHeaders(tenantCode?: string): Record<string, string> | undefined {
  return tenantCode ? { "X-Tenant-Code": tenantCode } : undefined;
}

export const tagService = {
  // 主域唯一入口 — 平台超管想看其他租户的 tags 通过 impersonation(代客登录)进入。
  // 历史 /kb-tags?tenantCode=... 路径不存在,已下架。
  list: () => api.get<KbTagDefinition[]>("/tenant/knowledge/tags"),
  create: (payload: CreateTagPayload) =>
    api.post<KbTagDefinition>("/tenant/knowledge/tags", payload),
  update: (id: number, payload: UpdateTagPayload) =>
    api.put<KbTagDefinition>(`/tenant/knowledge/tags/${id}`, payload),
  delete: (id: number) => api.delete<void>(`/tenant/knowledge/tags/${id}`),
  availability: (productCodes: string[], tags: string[] = []) => {
    const qs = new URLSearchParams();
    if (productCodes.length > 0) qs.set("productCodes", productCodes.join(","));
    if (tags.length > 0) qs.set("tags", tags.join(","));
    const q = qs.toString();
    return api.get<KbTagAvailability>(`/tenant/knowledge/tags/availability${q ? `?${q}` : ""}`);
  },
  syncScene: (tenantCode?: string) =>
    api.post<SyncSceneResult>("/tenant/knowledge/tags/sync-scene", null, {
      headers: tenantHeaders(tenantCode),
    }),
};
